import { render, staticRenderFns } from "./ExerciseForm.vue?vue&type=template&id=c2e85958&"
import script from "./ExerciseForm.vue?vue&type=script&lang=js&"
export * from "./ExerciseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports